module.exports = __webpack_public_path__ + "img/co-investing-6.76bd8f2d.jpg";